import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { isCandidateDataVisible } from '@core/candidate-util';
import type { InterviewEventWidget } from '@core/dashboard-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { AvatarComponent, AvatarRsvpBadge, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-interview-event-participants',
  templateUrl: 'interview-event-participants.component.html',
  styleUrls: ['./interview-event-participants.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.only-candidate]': 'onlyCandidate()' },
  imports: [AvatarComponent, RtTooltip, TranslatePipe],
})
export class InterviewEventParticipantsComponent {
  public readonly onlyCandidate = input<boolean>(undefined!);
  @Input() public event: InterviewEventWidget;

  public candidateRsvpStatuses: {
    [key: number]: AvatarRsvpBadge;
  } = {};
  public adminsRsvpStatuses: {
    [key: number]: AvatarRsvpBadge;
  } = {};
  public AvatarRsvpBadge = AvatarRsvpBadge;
  public isCandidateDataVisible: boolean = true;

  public rsvpStatusesTranslationKeys = {
    [AvatarRsvpBadge.Accepted]: 'app.interview.rsvp_status.accepted',
    [AvatarRsvpBadge.Declined]: 'app.interview.rsvp_status.declined',
    [AvatarRsvpBadge.Tentative]: 'app.interview.rsvp_status.tentative',
    [AvatarRsvpBadge.NeedsAction]: '',
  };

  public ngOnInit() {
    this.candidateRsvpStatuses = this.event.eventCandidateAttendees.reduce(
      (acc, v) => ({
        ...acc,
        [v.candidateId]: v.responseStatus,
      }),
      {},
    );

    this.adminsRsvpStatuses = this.event.eventAttendees.reduce(
      (acc, v) => ({
        ...acc,
        [v.adminId]: v.responseStatus,
      }),
      {},
    );
  }

  public ngOnChanges(): void {
    this.isCandidateDataVisible = isCandidateDataVisible(this.event.candidate);
  }
}
